const topics = [
  { name: '51黑料最新', count: '12.6万', color: 'primary' as const },
  { name: '91黑料入口', count: '11.3万', color: 'primary' as const },
  { name: '17黑料地址', count: '9.8万', color: 'accent' as const },
  { name: '718黑料合集', count: '8.9万', color: 'accent' as const },
  { name: '91黑料吃瓜', count: '8.2万', color: 'primary' as const },
  { name: '黑料51', count: '7.5万', color: 'secondary' as const },
  { name: '17黑料吃瓜视频', count: '6.7万', color: 'primary' as const },
  { name: '黑料718', count: '6.1万', color: 'secondary' as const },
  { name: '数字黑料', count: '5.4万', color: 'accent' as const },
  { name: '黑料合集入口', count: '4.8万', color: 'secondary' as const },
];

const colorClasses: Record<string, { bg: string; text: string; dot: string }> = {
  primary: { bg: 'bg-primary-100/60 hover:bg-primary-200/60', text: 'text-foreground-800', dot: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100/60 hover:bg-accent-200/60', text: 'text-foreground-800', dot: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100/60 hover:bg-secondary-200/60', text: 'text-foreground-800', dot: 'bg-secondary-500' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">话题热榜</h2>
          <p className="mt-2 text-sm text-foreground-600">当前最受关注的数字黑料话题标签</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => {
            const c = colorClasses[topic.color];
            return (
              <a
                key={idx}
                href="#index"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${c.bg} ${c.text} text-sm font-medium transition-colors cursor-pointer whitespace-nowrap`}
              >
                <span className={`w-2 h-2 rounded-full ${c.dot}`}></span>
                <span>{topic.name}</span>
                <span className="text-xs text-foreground-500">{topic.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}